import { BsArrowDown } from "react-icons/bs";
import styled, { keyframes } from "styled-components";

const floatAnimation = keyframes`
  0% { transform: translateY(0) }
  50% { transform: translateY(10px) }
  100% { transform: translateY(0) }
`;

interface SimpleHeroInnerProps {
  $contentWidth?: string;
}

export const SimpleHeroInner = styled.div<SimpleHeroInnerProps>`
  text-align: center;
  width: 100%;
  max-width: ${({ $contentWidth }) =>
    $contentWidth ? $contentWidth : "680px"};
`;

export const StyledArrowDown = styled(BsArrowDown)`
  position: absolute;
  bottom: 60px;
  left: 50%;
  margin-left: -1.25rem;
  font-size: 2.5rem;
  cursor: pointer;
  animation: ${floatAnimation} 3s ease-in-out 0s infinite;
`;
